import toast from "react-hot-toast";
import { IoSettings } from "react-icons/io5";
import { MdPrivacyTip } from "react-icons/md";
import { PiFolderUser } from "react-icons/pi";
import { persistor } from "../../redux/store";
import { HiMiniClipboard } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdLogOut, IoIosHelpCircle } from "react-icons/io";
import { FiActivity } from "react-icons/fi";
import { RiCustomerService2Line, RiGitRepositoryPrivateLine } from "react-icons/ri";
import { FaUserLargeSlash, FaRegUser, FaCookieBite } from "react-icons/fa6";
import { getPublicPrivateToggle, postPublicPrivateToggle } from "../../redux/ApiSlice/UserStatusSlice";
import { List, ListItem, ListItemPrefix, ListItemSuffix, Drawer, Card, Switch } from "@material-tailwind/react";
import { setClearHomepageVideos } from "../../redux/ApiSlice/HomePageVideoSlice";
import { logoutUser } from "../../redux/ApiSlice/LogoutSlice";
import { clearStorageKeepingPreferences } from "../../utils/userPreferences";

const AccountSidebar = ({ isDrawerOpen, closeDrawer }) => {
    const dispatch = useDispatch();
    const [toggleChecked, setToggleChecked] = useState({ is_private: false });
    const User_Status = useSelector((state) => state.UserPrivate_Status);
    const { User_PrivateStatus } = User_Status;
    const { user_data } = User_PrivateStatus;

    const navigate = useNavigate();
    const location = useLocation();

    const keepLogin = localStorage.getItem("keepMeLogin");
    const handleLogOut = async () => {
        try {
            // Call backend logout API to clear backend cookies
            await dispatch(logoutUser());
        } catch (error) {
            console.error("Logout error:", error);
        }
        localStorage.removeItem('accessToken');
        if (keepLogin) {
            localStorage.removeItem("security_login");
        } else {
            clearStorageKeepingPreferences();
            persistor.purge();
        }
        dispatch(setClearHomepageVideos())
        setTimeout(() => {
            navigate("/login");
        }, 500);
    };

    const handleChangeToggle = async (isChecked) => {
        setToggleChecked({ is_private: isChecked });
        await dispatch(postPublicPrivateToggle({ is_private: isChecked }));
        dispatch(getPublicPrivateToggle());

        if (!isChecked) {
            toast.success("Your account is now private");
        } else {
            toast.success("Your account is now public");
        }
    };

    const handleNavigate = (path) => {
        if (location.pathname === path) {
            return null;
        } else {
            navigate(path);
        }
    }

    const handleSelected = useCallback(() => {
        setToggleChecked({ is_private: user_data?.is_private });
    }, [user_data])

    useEffect(() => {
        handleSelected()
    }, [handleSelected]);

    return (
        <>
            <Drawer
                open={isDrawerOpen}
                onClose={closeDrawer}
                placement="right"
                className="absolute dark:bg-[#1E1D21] overflow-y-scroll w-4/5 md:w-5/6 lg:w-3/4"
                style={{ zIndex: 1, height: "100vh", overflow: "hidden" }}
            >
                <Card
                    color="transparent"
                    shadow={false}
                    style={{ zIndex: 1, height: "100vh" }}
                    className="overflow-y-scroll z-50 overflow-x-hidden"
                >
                    <p className="text-center text-black text-[18px] font-bold">
                        Settings & Privacy
                    </p>
                    <List>
                        {/* <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px] active:text-red-700  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/user/recommended")}>
                            <ListItemPrefix>
                                <FaUserCheck className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Recommended Friends
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px] active:text-red-700  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/user/suggestion")}>
                            <ListItemPrefix>
                                <RiUserAddFill className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Follow Suggestion
                        </ListItem> */}
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px] active:text-red-700  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/user/suggestion/friendship")}>
                            <ListItemPrefix>
                                <FaRegUser className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Friendship Suggestions
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px] active:text-red-700  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/user/suggestion/content-based")}>
                            <ListItemPrefix >
                                <PiFolderUser className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Content Based Friends
                        </ListItem>
                        <ListItem
                            className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]"
                        // onClick={() => handleChangeToggle(toggleChecked.is_private)}
                        >
                            <ListItemPrefix>
                                <RiGitRepositoryPrivateLine className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Private Account
                            <ListItemSuffix>
                                <Switch
                                    checked={toggleChecked.is_private}
                                    onChange={() => handleChangeToggle(toggleChecked.is_private)}
                                />
                            </ListItemSuffix>
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px] active:text-red-700  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/user/bloked/list")}>
                            <ListItemPrefix>
                                <FaUserLargeSlash className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Blocked Users
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px] active:text-red-700  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/settings/youractivity")}>
                            <ListItemPrefix>
                                <FiActivity className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Your Activity
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px] active:text-red-700  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/settings")}>
                            <ListItemPrefix>
                                <IoSettings className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Settings
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]" onClick={handleLogOut}>
                            <ListItemPrefix>
                                <IoMdLogOut className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Log Out
                        </ListItem>
                        {/* <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/settings/whatsnew")}>
                            <ListItemPrefix>
                                <FaRegNewspaper className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            What's New
                        </ListItem> */}
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/contact-us")}>
                            <ListItemPrefix>
                                <RiCustomerService2Line className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Contact Us
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/help")}>
                            <ListItemPrefix>
                                <IoIosHelpCircle className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Help
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/terms-of-use")}>
                            <ListItemPrefix>
                                <HiMiniClipboard className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Terms & Conditions
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/privacy-policy")}>
                            <ListItemPrefix>
                                <MdPrivacyTip className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Privacy Policy
                        </ListItem>
                        <ListItem className="dark:text-[#c9c8c8] md:text-[12px] lg:text-[14px]  dark:hover:bg-[#373737]" onClick={() => handleNavigate("/cookies")}>
                            <ListItemPrefix>
                                <FaCookieBite className="lg:h-5 lg:w-5 md:h-3 md:w-3" />
                            </ListItemPrefix>
                            Cookies Policy
                        </ListItem>
                    </List>
                </Card>
            </Drawer>
        </>
    );
};

export default AccountSidebar;